import { Grid, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { getUser } from 'src/utils/Common';

const useStyles = makeStyles((theme) => ({
  root: {},
  summaryButton: {
    backgroundColor: theme.palette.common.white
  },
  barChartIcon: {
    marginRight: theme.spacing(1)
  },
  image: {
    width: '100%',
    maxHeight: 400
  }
}));

function Header({ className, title, ...rest }) {
  const classes = useStyles();
  const SessionUser = getUser();
  const { t } = useTranslation('common');
  return (
    <div {...rest} className={clsx(classes.root, className)}>
      <Grid
        alignItems="center"
        container
        justify="space-between"
        spacing={3}
      >
        <Grid
          item
          md={12}
          xs={12}
        >
          <Typography
            component="h1"
            gutterBottom
            variant="h3"
          >
            {t('header_merhaba')}
            ,
            {' '}
            {SessionUser.FirstName}
            {' '}
            {SessionUser.LastName}
          </Typography>
          <Typography
            gutterBottom
            variant="subtitle1"
          >
            {title ? title : t('header_subtext')}
          </Typography>
        </Grid>
      </Grid>
    </div>
  );
}

Header.propTypes = {
  className: PropTypes.string
};

export default Header;
